import React, { Component } from "react"
import { ModalContainer, ModalDialog } from "react-modal-dialog"
import GestorForm from "./GestorForm"
import * as ApiHelper from "../../ApiHelper"
export default class GestoresModal extends Component {
  constructor() {
    super()
    this.callBackGestores = this.callBackGestores.bind(this)
    this.state = { isShowingModal: false }
  }
  getUnidades() {
    ApiHelper.getGestores(gestores => {
      if (gestores) {
        this.props.callBack(gestores)
      } else {
        console.log("Error")
      }
    })
  }
  callBackGestores() {
    this.getUnidades()
  }
  render() {
    return (
      <div onClick={this.props.onClose}>
        {this.props.show && (
          <ModalContainer onClose={this.props.onClose}>
            <ModalDialog style={{ width: "70%" }} onClose={this.props.onClose}>
              <GestorForm callBackGestores={this.callBackGestores} />
            </ModalDialog>
          </ModalContainer>
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/modais/GestoresModal.js